import React, { useEffect } from 'react';
import AppContext from './context';
import {AppContainer} from './global.styles';
import 'react-loading-skeleton/dist/skeleton.css'
import { useFeatureServices } from './use-feature-services';
import { RegionLocationV1, UserLocationManagerV1 } from '@volkswagen-onehub/user-location-manager';
import { Province } from '@vw-marketing/vw-ca-types';
import Dimension from './components/Dimension';
import Banner from './sections/Banner';

export const LocationContext = React.createContext<Province | null>(null);

export function App(): JSX.Element {

  const { 'user-location-manager': ulf } = useFeatureServices();

  const [ province, setProvince ] = React.useState<Province | null>(null);

  useEffect(() => {
    if (ulf) {
      ulf().then((manager) => {
        const userLocationManager = manager as UserLocationManagerV1;
        if (!userLocationManager.hasOwnProperty('userLocation')) {
          userLocationManager.promptUserForLocation();
        }

        userLocationManager.listen((userLocation) => {
          const ulfProvinceCode = (userLocation as RegionLocationV1).regionCode as Province;

          if(ulfProvinceCode) {
            setProvince(ulfProvinceCode);
          }
        })

      }).catch((error) => {
        console.error('Error while invoking user location feature', error);
      });
    }
  }, [ulf]);

  return (
    <LocationContext.Provider value={province}>
      <AppContext>
        <AppContainer id="compare-dimensions" tabIndex={-1}>
          <Dimension />
          <Banner />
        </AppContainer>
      </AppContext>
    </LocationContext.Provider>
  );
}
